import { useState } from "react";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import ContentPage from "../../Content";
import separateNumber from "../../../utils/separateur";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function DetailSitesPage({rowItem}){

    const [dateTime,setDateTime] = useState(new Date()) ;
    const [itemsList,setItemsList] = useState([]);
    const [itemsListFilter,setItemsListFilter] = useState([]);
    const [loading, setLoading] = useState(false);

    // console.log(rowItem);

    return (
        <>
        <div class="container-scroller" >



        <div class="container-fluid page-body-wrapper" style={{backgroundColor:"#C0C0C0"}}>
          <div class="main-panel">
              <div class="content-wrapper">

              <div class="accordion p-3" id="accordionExample">
                                    
                    <div class="accordion-item p-3">
                      <h2 class="accordion-header" id={`headingOne${1}`}>
                        <button class="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${1}`} aria-expanded="true" aria-controls={`collapseOne${1}`}>
                        {1} - {`NOM DU SITE : ${rowItem.Site}`}
                        </button>
                      </h2>
                      <div id={`collapseOne${1}`} class="accordion-collapse collapse show" aria-labelledby={`headingOne${1}`} data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                        <p><strong>Total Fonds de roulement du site {rowItem.Site} : </strong><b className="text-success">{ separateNumber(parseInt(rowItem.FondDeRoulementCommerciaux) + parseInt(rowItem.FondDeRoulementGesite)) } FCFA</b></p>
                        <div class="table-responsive">
                          <table class="table table-striped">
                            <thead> 
                              <tr className="bg-danger text-white fw-bold">
                                <th>ID</th>
                                <th>COMMERCIAL</th>
                                <th>SECTEUR</th>
                                <th>NOM GESITE</th>
                                <th>NUMERO GESITE</th>
                                <th  className="text-center">FDR COMMERCIAL</th>
                                <th  className="text-center">FDR GESITE</th>
                              </tr>
                            </thead>
                            <tbody>
                            {rowItem.commerciaux.map((row, index) => (
                              <tr key={index}>
                                <td class="py-1">
                                  <img src="../../../assets/images/faces-clipart/pic-1.png" alt="image"/>
                                </td>
                                <td>{row.Commercial}</td>
                                <td>
                                  {row.SecteurCommercial}
                                </td>
                                <td>
                                  {row.NomGesite}
                                </td>
                                <td className="text-center">
                                  {row.NumeroMarchandGesite}
                                </td>
                                <td className="text-center">
                                    <b className={row.FondDeRoulementCommercial > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FondDeRoulementCommercial)  }</b>
                                </td>     
                                <td className="text-center">
                                    <b className={row.FondRoulementGesite > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FondRoulementGesite)  }</b>
                                </td>                       
                                {/* <td>{vente.NumeroMarchandPOS}</td> */}
                              </tr>
                            ))}
                            </tbody>
                          </table>
                        </div>
                        </div>
                      </div>
                    </div>
                
                


                  </div>
              </div>

          {/* Footer page */}

          </div>
        </div>
        </div>
        </>
    );
}

export default DetailSitesPage;